import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await fetch('https://server.multisellerpro.com/api/auth/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: searchParams.get('email'),
        token: searchParams.get('token'),
        new_password: password
      })
    });
    const data = await res.json();
    if (data.success) {
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } else {
      setError(data.error || 'Link is invalid or expired');
    }
    setLoading(false);
  };

  if (done) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-xl text-center max-w-md w-full">
        <h2 className="text-2xl font-bold text-green-600">Password updated!</h2>
        <p className="text-gray-600 mt-2">Redirecting to login...</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Set New Password</h2>
        {error && <p className="text-red-600 mb-4">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="password" placeholder="New password (min 8 chars)" value={password}
            onChange={e => setPassword(e.target.value)} required minLength={8}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500" />
          <button type="submit" disabled={loading}
            className="w-full text-white py-3 rounded-lg font-semibold"
            style={{ background: 'linear-gradient(90deg, rgb(20,184,166), rgb(37,99,235))' }}>
            {loading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;